import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76a7c8d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "LogicalTransformerSectorAnimateContainer items-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-col gap-10"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "operateType"
}, [/*#__PURE__*/_createElementVNode("span", null, "顺时针旋转90度")]), /*#__PURE__*/_createElementVNode("div", {
  class: "operateType"
}, [/*#__PURE__*/_createElementVNode("span", null, "顺时针旋转180度")]), /*#__PURE__*/_createElementVNode("div", {
  class: "operateType"
}, [/*#__PURE__*/_createElementVNode("span", null, "左右翻转")])], -1));
const _hoisted_3 = {
  style: {
    "width": "260px",
    "height": "300px"
  },
  class: "flex justify-center items-center"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-col gap-10"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "operateType"
}, [/*#__PURE__*/_createElementVNode("span", null, "逆时针旋转90度")]), /*#__PURE__*/_createElementVNode("div", {
  class: "operateType"
}, [/*#__PURE__*/_createElementVNode("span", null, "逆时针旋转180度")]), /*#__PURE__*/_createElementVNode("div", {
  class: "operateType"
}, [/*#__PURE__*/_createElementVNode("span", null, "上下翻转")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [$data.playing ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.animateImage[$data.animateKey],
    style: {
      "width": "260px"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $options.play && $options.play(...args))
  }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $data.paused,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.play && $options.play(...args)),
    style: {
      "width": "100px",
      "height": "100px"
    },
    class: "cursor-pointer"
  }, null, 8, _hoisted_5))]), _hoisted_6]);
}